import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaSync } from "react-icons/fa";

export default function PayoutChart() {
  const navigate = useNavigate();

  const payouts = [
    { usd: "15.00", coins: "9750" },
    { usd: "30.00", coins: "19500" },
    { usd: "50.00", coins: "32500" },
    { usd: "75.00", coins: "48750" },
    { usd: "100.00", coins: "65000" },
    { usd: "150.00", coins: "97500" },
    { usd: "250.00", coins: "162500" },
    { usd: "375.00", coins: "243750" },
    { usd: "750.00", coins: "487500" },
  ];

  return (
    <div className="fixed inset-0 bg-black z-[999] overflow-y-auto">
      {/* HEADER */}
      <div className="sticky top-0 bg-[#121212] border-b border-white/10 flex items-center px-4 py-3">
        <button
          onClick={() => navigate(-1)}
          className="
            p-2 rounded-full
            hover:bg-[#1a1a1a]
            active:scale-95 transition
          "
        >
          <FaArrowLeft className="text-red-500 text-lg" />
        </button>

        <h1 className="text-lg font-bold text-red-500 w-full text-center mr-8">
          PAYOUT CHART
        </h1>
      </div>

      {/* INFO BAR */}
      <div className="bg-[#1a1a1a] py-2 px-4 text-center text-gray-400 text-sm flex justify-center items-center gap-2 border-b border-white/10">
        <span className="text-yellow-500 text-lg">●</span>
        You can convert to money from cashout
        <span className="text-yellow-500 text-lg">●</span>
      </div>

      {/* LIST */}
      <div className="p-4 space-y-3">
        {payouts.map((item, index) => (
          <div
            key={index}
            className="
              w-full
              bg-[#121212]
              rounded-2xl
              border border-white/10
              flex items-center justify-between
              px-4 py-4
            "
          >
            {/* USD */}
            <p className="text-[18px] font-bold text-orange-400">
              {item.usd} USD
            </p>

            {/* Swap Icon */}
            <FaSync className="text-gray-500 text-lg" />

            {/* Coins Pill */}
            <div className="bg-black border border-white/20 px-4 py-2 rounded-full flex items-center gap-2">
              <span className="text-yellow-500 text-xl">🟡</span>
              <span className="text-gray-200 font-semibold">{item.coins}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="h-10" />
    </div>
  );
}
